/* eslint-disable */
import React, { useEffect, useState } from "react";
import styles from "./Layout.module.css";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../RootReducer";
import {
  filterVideoList,
  InvisibleLoading,
  VisibleLoading,
} from "../../../common/video/VideoActions";
// import TimeSnapLogoIcon from "../../../../public/xenera-logo.png";
import PuiMessage from "../../../components/widgets/PuiMessage";
import PuiTypography from "../../../components/elements/PuiTypography";
import {
  MSG_LOGIC_DELETE_FAILED,
  MSG_LOGIC_DELETE_FINISH,
  MSG_LOGIC_INSERT_FAILED,
  MSG_LOGIC_UPDATE_FAILED,
  MSG_LOGIC_UPDATE_FINISH,
} from "../../../utils/Messages";
import { setMessageArgs } from "../../../utils/LogicUtils";
import { Outlet } from "react-router-dom";
import ScrollToTop from "src/common/components/scroll/ScrollToTop";



function Layout() {
  const {
    userInfo,
    isSendVideo,
    isSuccessSendVideo,
    isFailedSendVideo,
    isEditVideo,
    isSuccessEditVideo,
    isFailedEditVideo,
    failedVideoTitle,
    isUploadDocument,
    isSuccessUploadDocument,
    isFailedUploadDocument,
    isDeleteVideo,
    isSuccessDeleteVideo,
    isFailedDeleteVideo,
    isUpdateRecVideos,
    isUpdateSuccessRecVideos,
    isUpdateFailedRecVideos,
    isUpdateRecPrograms,
    isUpdateSuccessRecPrograms,
    isUpdateFailedRecPrograms,
    isUpdateRecProfessionals,
    isUpdateSuccessRecProfessionals,
    isUpdateFailedRecProfessionals,
    isUpdateUserInfo,
    isSuccessUpdateUserInfo,
    isFailedUpdateUserInfo,
    isSuccessUpdateUserProfileImage,
    isFailedUpdateUserProfileImage,
    isEditSTT,
    isSuccessEditSTT,
    isFailedEditSTT,
    isRerunSTT,
    isSuccessRerunSTT,
    isFailedRerunSTT,
    isUpdatePublicStateStt,
    isSuccessUpdatePublicStateStt,
    isFailedUpdatePublicStateStt,
    videoPdf,
    isUpdateVideoSlide,
    isSuccessUpdateVideoSlide,
    isFailedUpdateVideoSlide,
    isDeleteVideoSlide,
    isSuccessDeleteVideoSlide,
    isFailedDeleteVideoSlide,
    isUpdatingSurveyList,
    isSuccessUpdateSurveyList,
    isFailedUpdateSurveyList,
  } = useSelector((state: AppState) => ({
    userInfo: state.user.userInfo,
    loadingUser: state.user.isLoading,
    isSendVideo: state.video.isSendVideo,
    isSuccessSendVideo: state.video.isSuccessSendVideo,
    isFailedSendVideo: state.video.isFailedSendVideo,
    isEditVideo: state.video.isEditVideo,
    isSuccessEditVideo: state.video.isSuccessEditVideo,
    isFailedEditVideo: state.video.isFailedEditVideo,
    failedVideoTitle: state.video.failedVideoTitle,
    isUploadDocument: state.video.isUploadDocument,
    isSuccessUploadDocument: state.video.isSuccessUploadDocument,
    isFailedUploadDocument: state.video.isFailedUploadDocument,
    isDeleteVideo: state.video.isDeleteVideo,
    isSuccessDeleteVideo: state.video.isSuccessDeleteVideo,
    isFailedDeleteVideo: state.video.isFailedDeleteVideo,
    isUpdateRecVideos: state.recommendList.isUpdateRecVideos,
    isUpdateSuccessRecVideos: state.recommendList.isUpdateSuccessRecVideos,
    isUpdateFailedRecVideos: state.recommendList.isUpdateFailedRecVideos,
    isUpdateRecPrograms: state.recommendList.isUpdateRecPrograms,
    isUpdateSuccessRecPrograms: state.recommendList.isUpdateSuccessRecPrograms,
    isUpdateFailedRecPrograms: state.recommendList.isUpdateFailedRecPrograms,
    isUpdateRecProfessionals: state.recommendList.isUpdateRecProfessionals,
    isUpdateSuccessRecProfessionals:
      state.recommendList.isUpdateSuccessRecProfessionals,
    isUpdateFailedRecProfessionals:
      state.recommendList.isUpdateFailedRecProfessionals,
    isUpdateUserInfo: state.user.isUpdateUserInfo,
    isSuccessUpdateUserInfo: state.user.isSuccessUpdateUserInfo,
    isFailedUpdateUserInfo: state.user.isFailedUpdateUserInfo,
    isSuccessUpdateUserProfileImage: state.user.isSuccessUpdateUserProfileImage,
    isFailedUpdateUserProfileImage: state.user.isFailedUpdateUserProfileImage,
    isEditSTT: state.exVideo.caption.isEditSTT,
    isSuccessEditSTT: state.exVideo.caption.isSuccessEditSTT,
    isFailedEditSTT: state.exVideo.caption.isFailedEditSTT,
    isRerunSTT: state.exVideo.caption.isRerunSTT,
    isSuccessRerunSTT: state.exVideo.caption.isSuccessRerunSTT,
    isFailedRerunSTT: state.exVideo.caption.isFailedRerunSTT,
    isUpdatePublicStateStt: state.exVideo.caption.isUpdatePublicStateStt,
    isSuccessUpdatePublicStateStt:
      state.exVideo.caption.isSuccessUpdatePublicStateStt,
    isFailedUpdatePublicStateStt:
      state.exVideo.caption.isFailedUpdatePublicStateStt,
    videoPdf: state.video.videoPdf,
    isUpdateVideoSlide: state.video.isUpdateVideoSlide,
    isSuccessUpdateVideoSlide: state.video.isSuccessUpdateVideoSlide,
    isFailedUpdateVideoSlide: state.video.isFailedUpdateVideoSlide,
    isDeleteVideoSlide: state.video.isDeleteVideoSlide,
    isSuccessDeleteVideoSlide: state.video.isSuccessDeleteVideoSlide,
    isFailedDeleteVideoSlide: state.video.isFailedDeleteVideoSlide,
    isUpdatingSurveyList: state.Survey.isUpdatingSurveyList,
    isSuccessUpdateSurveyList: state.Survey.isSuccessUpdateSurveyList,
    isFailedUpdateSurveyList: state.Survey.isFailedUpdateSurveyList,
  }));

  const dispatch = useDispatch();

  // 成功・失敗メッセージ
  const [isSuccessMessage, VisibleSuccess] = useState(false);
  const [isFailedMessage, VisibleFailed] = useState(false);
  const [messageTest, SetMessageText] = useState<React.ReactNode>(undefined);
  const [failedDetail, SetFailedDetail] = useState<React.ReactNode[]>([]);
  const CloseMessage = () => {
    VisibleSuccess(false);
    VisibleFailed(false);
    SetMessageText(undefined);
    SetFailedDetail([]);
  };

  // -------------------- 新規ビデオアップロード --------------------
  // バックエンドに送信中フラグ
  const [isStartSendVideo, ChangeStartSendVideoFlag] = useState(false);
  useEffect(() => {
    if (isSendVideo === true) {
      ChangeStartSendVideoFlag(true);
    } else {
      if (isStartSendVideo === true) {
        if (isSuccessSendVideo === true) {
          VisibleSuccess(true);
          SetMessageText(
            <span>
              Videoのアップロード準備が完了しました。続けてVideoをアップロードできます
              <br />
              現在のアップロード状況は管理画面で確認できます。Videoサイズによっては反映に時間がかかる場合があります。
            </span>
          );
        }
        if (isFailedSendVideo === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_INSERT_FAILED, "Video"));
        }
        ChangeStartSendVideoFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSendVideo, isSuccessSendVideo, isFailedSendVideo]);

  // -------------------- ビデオ情報データアップデート --------------------
  // バックエンドに送信中フラグ
  const [isStartEditVideo, ChangeStartEditVideoFlag] = useState(false);
  useEffect(() => {
    if (isEditVideo === true) {
      ChangeStartEditVideoFlag(true);
      dispatch(VisibleLoading());
    }
    // TODO 資料アップロード→再生
    // if(isUploadDocument === true){
    //     VisibleSuccess(true);
    //     SetMessageText(<span>Videoを更新しました。<br/>サムネイルの更新がある場合は、画面をリフレッシュしてください。</span>);
    //}
    if (isEditVideo === false && isUploadDocument === false) {
      if (isStartEditVideo === true) {
        if (isFailedEditVideo === true || isFailedUploadDocument === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "Video"));
          SetFailedDetail([
            <PuiTypography key={1}>{failedVideoTitle}</PuiTypography>,
          ]);
        }
        if (isSuccessEditVideo === true || isSuccessUploadDocument === true) {
          VisibleSuccess(true);
          SetMessageText(
            <span>
              Videoを更新しました。
              <br />
              サムネイルの更新がある場合は、画面をリフレッシュしてください。
            </span>
          );
        }
        if (userInfo) {
          dispatch(
            filterVideoList(userInfo.id, {
              id: [],
              professional: [],
              program: [],
              project: [],
              tag: [],
            })
          );
        }
        dispatch(InvisibleLoading());
        ChangeStartEditVideoFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isEditVideo,
    isSuccessEditVideo,
    isFailedEditVideo,
    isUploadDocument,
    isSuccessUploadDocument,
    isFailedUploadDocument,
  ]);

  // -------------------- ビデオ削除 --------------------
  // バックエンドに送信中フラグ
  const [isStartDeleteVideo, ChangeStartDeleteVideoFlag] = useState(false);
  useEffect(() => {
    if (isDeleteVideo === true) {
      ChangeStartDeleteVideoFlag(true);
      dispatch(VisibleLoading());
    } else {
      if (isStartDeleteVideo === true) {
        if (isSuccessDeleteVideo === true) {
          VisibleSuccess(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_DELETE_FINISH, "Video"));
        }
        if (isFailedDeleteVideo === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_DELETE_FAILED, "Video"));
        }
        if (userInfo) {
          dispatch(
            filterVideoList(userInfo.id, {
              id: [],
              professional: [],
              program: [],
              project: [],
              tag: [],
            })
          );
        }
        dispatch(InvisibleLoading());
        ChangeStartDeleteVideoFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteVideo, isSuccessDeleteVideo, isFailedDeleteVideo]);

  // -------------------- おすすめ管理データアップデート --------------------
  // バックエンドに送信中フラグ
  const [isStartUpdateRecommend, ChangeStartRecommendFlag] = useState(false);
  useEffect(() => {
    if (
      isUpdateRecVideos === true ||
      isUpdateRecPrograms === true ||
      isUpdateRecProfessionals === true
    ) {
      ChangeStartRecommendFlag(true);
    }
    if (
      isUpdateRecVideos === false &&
      isUpdateRecPrograms === false &&
      isUpdateRecProfessionals === false
    ) {
      if (isStartUpdateRecommend === true) {
        if (
          isUpdateFailedRecVideos === true ||
          isUpdateFailedRecPrograms === true ||
          isUpdateFailedRecProfessionals === true
        ) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "おすすめ"));
        }
        if (
          isUpdateSuccessRecVideos === true ||
          isUpdateSuccessRecPrograms === true ||
          isUpdateSuccessRecProfessionals === true
        ) {
          VisibleSuccess(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FINISH, "おすすめ"));
        }
        ChangeStartRecommendFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateRecVideos, isUpdateRecPrograms, isUpdateRecProfessionals]);

  // -------------------- ユーザー管理データアップデート --------------------
  // バックエンドに送信中フラグ
  const [isStartUpdateUsers, ChangeStartUsersFlag] = useState(false);
  useEffect(() => {
    if (isUpdateUserInfo === true) {
      ChangeStartUsersFlag(true);
    } else {
      if (isStartUpdateUsers === true) {
        if (isSuccessUpdateUserInfo === true) {
          VisibleSuccess(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FINISH, "User"));
        }
        if (isFailedUpdateUserInfo === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "User"));
        }
        ChangeStartUsersFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateUserInfo, isSuccessUpdateUserInfo, isFailedUpdateUserInfo]);

  // -------------------- ユーザープロファイルイメージアップデート --------------------
  // バックエンドに送信中フラグ
  const [message, setMessage] = useState<string | undefined>(undefined);

  const CloseMessageBar = () => {
    setMessage(undefined);
  };

  useEffect(() => {
    if (isSuccessUpdateUserProfileImage === true) {
      setMessage("成功");
    } else if (isFailedUpdateUserProfileImage === true) {
      setMessage("失敗");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccessUpdateUserProfileImage, isFailedUpdateUserProfileImage]);

  // -------------------- ビデオSTT編集 --------------------
  // バックエンドに送信中フラグ
  const [isStartEditSTT, ChangeStartEditSTTFlag] = useState(false);
  useEffect(() => {
    if (isEditSTT === true) {
      ChangeStartEditSTTFlag(true);
    } else {
      if (isStartEditSTT === true) {
        if (isSuccessEditSTT === true) {
          VisibleSuccess(true);
          SetMessageText(
            setMessageArgs(MSG_LOGIC_UPDATE_FINISH, "キャプション")
          );
        }
        if (isFailedEditSTT === true) {
          VisibleFailed(true);
          SetMessageText(
            setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "キャプション")
          );
        }
        ChangeStartEditSTTFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditSTT, isSuccessEditSTT, isFailedEditSTT]);

  // -------------------- ビデオSTT再実行 --------------------
  // バックエンドに送信中フラグ
  const [isStartRerunSTT, ChangeStartRerunSTTFlag] = useState(false);
  useEffect(() => {
    if (isRerunSTT === true) {
      ChangeStartRerunSTTFlag(true);
    } else {
      if (isStartRerunSTT === true) {
        if (isSuccessRerunSTT === true) {
          VisibleSuccess(true);
          SetMessageText(
            <span>
              STTを再実行中です
              <br />
              アップロード状況は管理画面で確認できます
            </span>
          );
        }
        if (isFailedRerunSTT === true) {
          VisibleFailed(true);
          SetMessageText("STTの再実行に失敗しました");
        }
        ChangeStartRerunSTTFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRerunSTT, isSuccessRerunSTT, isFailedRerunSTT]);

  // -------------------- ビデオSTT公開ステータス更新 --------------------
  // バックエンドに送信中フラグ
  const [isStartUpdatePublicStateStt, ChangeStartUpdatePublicStateSttFlag] =
    useState(false);
  useEffect(() => {
    if (isUpdatePublicStateStt === true) {
      ChangeStartUpdatePublicStateSttFlag(true);
    } else {
      if (isStartUpdatePublicStateStt === true) {
        if (isSuccessUpdatePublicStateStt === true) {
          VisibleSuccess(true);
          SetMessageText(
            setMessageArgs(
              MSG_LOGIC_UPDATE_FINISH,
              "キャプションの公開ステータス"
            )
          );
        }
        if (isFailedUpdatePublicStateStt === true) {
          VisibleFailed(true);
          SetMessageText(
            setMessageArgs(
              MSG_LOGIC_UPDATE_FAILED,
              "キャプションの公開ステータス"
            )
          );
        }
        ChangeStartUpdatePublicStateSttFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isUpdatePublicStateStt,
    isSuccessUpdatePublicStateStt,
    isFailedUpdatePublicStateStt,
  ]);

  // -------------------- スライド編集 --------------------
  // バックエンドに送信中フラグ
  const [isStartUpdateVideoSlide, ChangeStartUpdateVideoSlideFlag] =
    useState(false);
  useEffect(() => {
    if (isUpdateVideoSlide === true) {
      ChangeStartUpdateVideoSlideFlag(true);
      dispatch(VisibleLoading());
    } else {
      if (isStartUpdateVideoSlide === true) {
        if (isSuccessUpdateVideoSlide === true) {
          if (videoPdf?.isPublic) {
            VisibleSuccess(true);
            SetMessageText(
              <span>
                Slideを更新しました。
                <br />
                現在、Slideはユーザーに公開されています。
              </span>
            );
          } else {
            VisibleSuccess(true);
            SetMessageText(
              <span>
                Slideを更新しました。
                <br />
                ユーザーにSlideを公開するには公開設定をONにしてください。
              </span>
            );
          }
        }
        if (isFailedUpdateVideoSlide === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "Slide"));
        }
        if (userInfo) {
          dispatch(
            filterVideoList(userInfo.id, {
              id: [],
              professional: [],
              program: [],
              project: [],
              tag: [],
            })
          );
        }
        dispatch(InvisibleLoading());
        ChangeStartUpdateVideoSlideFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUpdateVideoSlide, isSuccessUpdateVideoSlide, isFailedUpdateVideoSlide]);

  // -------------------- スライド削除 --------------------
  const [isStartDeleteVideoSlide, ChangeStartDeleteVideoSlideFlag] =
    useState(false);
  useEffect(() => {
    if (isDeleteVideoSlide === true) {
      ChangeStartDeleteVideoSlideFlag(true);
      dispatch(VisibleLoading());
    } else {
      if (isStartDeleteVideoSlide === true) {
        if (isSuccessDeleteVideoSlide === true) {
          VisibleSuccess(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_DELETE_FINISH, "スライド"));
        }
        if (isFailedDeleteVideoSlide === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_DELETE_FAILED, "スライド"));
        }
        if (userInfo) {
          dispatch(
            filterVideoList(userInfo.id, {
              id: [],
              professional: [],
              program: [],
              project: [],
              tag: [],
            })
          );
        }
        dispatch(InvisibleLoading());
        ChangeStartDeleteVideoSlideFlag(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteVideoSlide, isSuccessDeleteVideoSlide, isFailedDeleteVideoSlide]);

  // -------------------- アンケート編集 --------------------
  // バックエンドに送信中フラグ
  const [isStartUpdateSurvey, ChangeStartUpdateSurveyFlag] = useState(false);
  useEffect(() => {
    if (isUpdatingSurveyList === true) {
      ChangeStartUpdateSurveyFlag(true);
      dispatch(VisibleLoading());
    } else {
      if (isStartUpdateSurvey === true) {
        if (isSuccessUpdateSurveyList === true) {
          VisibleSuccess(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FINISH, "アンケート"));
        }
        if (isFailedUpdateSurveyList === true) {
          VisibleFailed(true);
          SetMessageText(setMessageArgs(MSG_LOGIC_UPDATE_FAILED, "アンケート"));
        }
        if (userInfo) {
          dispatch(
            filterVideoList(userInfo.id, {
              id: [],
              professional: [],
              program: [],
              project: [],
              tag: [],
            })
          );
        }
        dispatch(InvisibleLoading());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isUpdatingSurveyList,
    isSuccessUpdateSurveyList,
    isFailedUpdateSurveyList,
  ]);

  return (
    <div className={styles.root}>
      <ScrollToTop/>
      <PuiMessage
        open={isSuccessMessage}
        duration={4000}
        type="success"
        title={messageTest}
        onClose={CloseMessage}
      />

      <PuiMessage
        open={isFailedMessage}
        type="error"
        title={messageTest}
        detail={
          failedDetail && failedDetail.length > 0 ? failedDetail : undefined
        }
        onClose={CloseMessage}
      />

      {/* ビデオアップロード */}
      <div className={styles.updaloadngVideoMessage}>
        <PuiMessage
          open={isSendVideo}
          type="info"
          title={
            <span>
              Videoのアップロード準備中です。
              <br />
              ブラウザ画面を更新しないでください。
            </span>
          }
        />
      </div>

      {/* ビデオ情報アップデート */}
      <PuiMessage
        open={isEditVideo}
        type="info"
        title="Videoを更新しています。ブラウザ画面を更新しないでください"
      />
      <PuiMessage
        open={isUpdateUserInfo}
        type="info"
        title="Userを更新しています。ブラウザ画面を更新しないでください"
      />

      {/* ユーザープロファイルイメージアップデート */}
      <PuiMessage
        open={message !== undefined ? true : false}
        onClose={CloseMessageBar}
        type={isSuccessUpdateUserProfileImage ? "success" : "error"}
        title={<span>プロファイル写真の更新に{message}しました</span>}
      />

      <Header />
      <div className={styles.content}>
        <div className={styles.upperContent}>
          <div className={styles.contentBody}>
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
